<!--
通用普通页面模板
-->
<style lang="less" scoped>
  @import "~@/public/less/index.less";
  .z-plugin-list{
    width: 100%; height: 100% !important; overflow: hidden;
    .head{
      margin: 0 20px 20px 20px; font-size: 1.1em; font-weight: bold;
    }
    .subHead{
      margin: 0 20px 20px 20px;
    }
  }
</style>
<template>
  <div class="zee zee-component z-plugin-list">
    <z-layout ref="zlayout"
              v-if="superApi && superColumns"
              :superPage="page"
              :superApi="superApi"
              @reloadData="loadData">
      <!-- 面包屑 -->
      <template #breadcrumb><div></div></template>
      <!-- 头部 -->
      <template #head v-if="superTitle || $slots.subHead">
        <div class="head" v-if="superTitle">{{superTitle}}</div>
        <div class="subHead" v-if="$slots.subHead"><slot name="subHead"></slot></div>
      </template>
      <!-- 检索 -->
      <template #subHeadLeft v-if="$slots.subHeadLeft">
        <slot name="subHeadLeft"></slot>
      </template>
       <template #subHeadLeft v-else>
        <z-search :superFilter="page.filter"
                  :superColumns="superColumns"
                  @change="bindSearchChange"
                  @reloadData="reloadData()">
        </z-search>
      </template>

      <!-- 子菜单 -->

      <!-- 列表 -->
      <template #body>
          <div class="table-operations" style="margin-bottom:20px;">
              <slot name="subHeadbom"></slot>
          </div>
        <z-table v-if="data.data"
                 ref="ztable"
                 :superData="data"
                 :superColumns="superColumns"
                 :superFilter="page.filter"
                 @change="bindTableChange">
          <template #actions="record">
            <slot name="actions" :record="record.record"></slot>
            <!--customActions start-->
            <slot name="customActions" :record="record.record"></slot>
            <template v-if="!$slots.customActions">
              <a-tooltip content="查看" position="bottom">
                <a-button @click="$refs.zlayout.bindOpenCurd('详情', record)"><template #icon><icon-eye /></template></a-button>
              </a-tooltip>
              <a-tooltip content="编辑" position="bottom">
                <a-button @click="$refs.zlayout.bindOpenCurd('编辑', record)"><template #icon><icon-edit /></template></a-button>
              </a-tooltip>
              <a-popconfirm content="删除不可恢复，是否继续？" position="br" @ok="bindDeleteRecord(record)">
                <a-tooltip position="bottom" content="删除" >
                  <a-button status="danger"><template #icon><icon-delete /></template></a-button>
                </a-tooltip>
              </a-popconfirm>
            </template>
            <!--customActions end-->
          </template>
        </z-table>
      </template>
    </z-layout>
  </div>
</template>

<script>
  import moment from 'moment'
  import 'moment/locale/zh-cn'
  moment.locale('zh-cn')
  export default {
    name: 'FPluginList',
    props: {
      superTitle: String,
      superApi: String,
      superColumns: Array
    },
    created() {
      this.page = this.$fan.utils.parse(this.def.page)
      this.data = this.$fan.utils.parse(this.def.data)
    },
    async mounted() {
      if (this.superApi && this.superColumns) {
        await this.reloadData()
      }
    },
    computed: {
      routers() {
        return this.$store.state.routers || {}
      },
      router() {
        return this.routers[this.$route.path] || {}
      },
      query() {
        const query = this.$route.query
        if (this.$fan.utils.notEmpty(query)) {
          return query
        } else {
          return false
        }
      },
      menus() {
        let menus = {}
        if (this.router && this.router.navInfo && this.router.navInfo.hasChild) {
          for (let k in this.routers) {
            const router = this.routers[k]
            let routerNavUrl = ""
            for (let i =0; i < this.router.navInfo.level; i++) {
              routerNavUrl = routerNavUrl+"/"+router.info.path[i]
            }
            if (router.info.type!=='nav' && routerNavUrl===this.router.navInfo.url) {
              menus[router.info.url] = router
            }
          }
        }
        return Object.keys(menus).length>0 ? menus : false
      }
    },
    data() {
      return {
        data: {}, page: {},
        def: {
          data: {},
          page: {
            initing: false,
            loading: false,
            filter: {
              page: 1,
              limit: 10
            }
          }
        }
      }
    },
    methods: {
      async loadData() {
        this.page.loading = true
        const {data} = await this.$fan.api.get(this.superApi, this.page.filter)
        this.data = data
        this.$store.state.page.data = data
        this.page.loading = false
      },
      async reloadData() {
        this.page.initing = true
        this.page.filter = this.$fan.utils.parse(this.def.page.filter)
        await this.loadData()
        await this.$fan.page.loadCallback(this.superColumns, this.data)
        this.page.initing = false
      },
      async bindSearchChange(filter={}) {
        this.page.loading = true
        this.page.filter = {...filter, ...this.def.page.filter}
        await this.loadData()
        await this.$fan.page.loadCallback(this.superColumns, this.data)
        this.page.loading = false
      },
      bindTableChange(pagination, filters, sorter) {
        this.page.filter.page = pagination.current
        this.page.filter.limit = pagination.pageSize
        this.loadData()
      },
      async bindDeleteRecord({record}) {
        let api = this.superApi.split('?')[0]
        await this.$fan.api.delete(`${api}/${record.id}`)
        this.loadData()
      },
      async exportexcel() {
        let xlsColumns = []
        const columns = this.superColumns
        const data = JSON.parse(JSON.stringify(this.data.data))
        for (let k in columns) {
          if ([
            'Id', 'ID', '操作'
          ].indexOf(columns[k].title) < 0) {
            xlsColumns.push({
              label: columns[k].title,
              prop: columns[k].dataIndex
            })
            if (columns[k].form == 'monthpicker') {
              for (let kk in data) {
                data[kk][columns[k].dataIndex] = moment(data[kk][columns[k].dataIndex]).format('YYYY.MM')
              }
            }
          }
        }
        this.$export.csv({
          columns: xlsColumns,
          data: data
        })
      },
    }
  }
</script>
